<template>
  <BonatitanNav>404</BonatitanNav>
  <div class="mt-lg">
    <PaytandCry />
  </div>
  <section class="l-section--form --ta-center mt-lg">
    <BonatitanOutputField>お探しのページが<br />見つかりませんでした。</BonatitanOutputField>
    <div class="c-textbox">
      <BonatitanDescription>
        考えられるケース：
        <ul>
          <li>URLが間違っている</li>
          <li>ご家族宛に送られたURLにアクセスしている</li>
        </ul>
      </BonatitanDescription>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import PaytandCry from '~/assets/paytand_cry_anim.vue'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true,
  },
})
</script>

<style lang="scss" scoped>
ul {
  margin-top: 5px;
}
</style>
